module.exports = __webpack_public_path__ + "static/media/hbobg.b16d7f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hbobg.png
// module id = 19
// module chunks = 0